import { ServiceController } from "Util/serviceController";

export function registerEnergyStorageSystemService(pageController, energyStorageSystemState, serviceControllers) {
    serviceControllers.EnergyStorageSystem = new EnergyStorageSystemService(energyStorageSystemState, pageController);
}

class EnergyStorageSystemService extends ServiceController {
    constructor(state, pageController) {
        super(state, pageController);
        this.equipmentModelCache = {};
    }
    getEquipmentManufacturers(equipmentType) {
        let manufacturers = this.EquipmentManufacturers || [];
        manufacturers = manufacturers.filter(function (m) {
            return m.EquipmentType === equipmentType;
        });
        return manufacturers;
    }
    async getEquipmentModels(equipmentType, manufacturerName) {
        if (this.equipmentModelCache[equipmentType] == undefined) {
            this.equipmentModelCache[equipmentType] = {};
        }
        if (this.equipmentModelCache[equipmentType][manufacturerName] == undefined) {
            const result = await this.GetEquipmentModels({
                programId: this.ProgramId,
                equipmentType: equipmentType,
                manufacturerName: manufacturerName
            });
            this.equipmentModelCache[equipmentType][manufacturerName] = result.Data;
        }
        return this.equipmentModelCache[equipmentType][manufacturerName];
    }
    async getEquipmentModelName(equipmentType, modelId) {
        const result = await this.GetEquimentModelName({
            programId: this.ProgramId,
            equipmentType: equipmentType,
            modelId: modelId
        });
        return result.Data.Name;
    }
    getEquipmentModel(modelId) {
        for (const equipmentType in this.equipmentModelCache) {
            for (const manufacturerId in this.equipmentModelCache[equipmentType]) {
                const found = this.equipmentModelCache[equipmentType][manufacturerId].find(
                    (x) => x.ModelId === modelId
                );
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }
}
